import isTagged from './isTagged';
import { planTagsConfig } from '../config/plan-group-config';

export const isXoPlusPlan = plan =>
  plan?.groupName?.toUpperCase().includes('XO PLUS PLANS');

const is5gXoPlusPlan = plan => {
  const speedTag = isTagged(plan?.tags, planTagsConfig['5g-speed'].tagName);
  return speedTag && isXoPlusPlan(plan);
};

export default is5gXoPlusPlan;
